import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-od-service-policy',
  templateUrl: './terms-od-service-policy.component.html',
  styleUrls: ['./terms-od-service-policy.component.css']
})
export class TermsOdServicePolicyComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }
}
